import React from "react";
import { FormattedMessage } from "react-intl";

export default function APLPresenceColorInfo() {
  return (
    <>
      <div className="apl-presence__legend-item">
        <span className="apl-presence__legend-dot apl-presence__legend-dot--present" />
        <FormattedMessage id="Present" />
      </div>
      <div className="apl-presence__legend-item">
        <span className="apl-presence__legend-dot apl-presence__legend-dot--absent" />
        <FormattedMessage id="Absent" />
      </div>
      <div className="apl-presence__legend-item">
        <span className="apl-presence__legend-dot apl-presence__legend-dot--empty" />
        <FormattedMessage id="NoCheckIn" />
      </div>
    </>
  );
}
